<div class="container-style py-2">
  <app-custom-table [showRecover]="true" [showExport]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="url" (onPageChange)="onPageChange($event)"
    (onRecoverData)="getAllConceptFamiliesForAccountingModelWithPagination()" (onExport)="onExport()"
    (onFilterChange)="onFilterChange($event)">
  </app-custom-table>
</div>